/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable */

import {createTheme, lightThemePrimitives} from 'baseui'
import {getMediaQuery} from 'baseui/helpers/responsive-helpers'

import {breakpoints, colors, sizing} from './config'

const responsivePrimitives = Object.keys(breakpoints).reduce(
  (acc, key) => {
    acc.breakpoints[key] = breakpoints[key]
    acc.media[key] = getMediaQuery(breakpoints[key])
    return acc
  },
  {
    breakpoints: {},
    media: {},
  },
)

export const lightTheme = createTheme(
  {
    ...lightThemePrimitives,
    name: 'light-theme',
    primaryFontFamily: '"Proxima Soft", system-ui, "Helvetica Neue", Helvetica, Arial, sans-serif',
    primaryA: colors.mono1000,
    primaryB: colors.white,
    primary: colors.yellow400,
    primary50: colors.yellow50,
    primary100: colors.yellow100,
    primary200: colors.yellow200,
    primary300: colors.yellow300,
    primary400: colors.yellow400,
    primary500: colors.yellow500,
    primary600: colors.yellow600,
    primary700: colors.yellow700,
    mono100: colors.mono100,
    mono200: colors.mono200,
    mono300: colors.mono300,
    mono400: colors.mono400,
    mono500: colors.mono500,
    mono600: colors.mono600,
    mono700: colors.mono700,
    mono800: colors.mono800,
    mono900: colors.mono900,
    mono1000: colors.mono1000,
  },
  {
    ...responsivePrimitives,
    borders: {
      useRoundedCorners: true,
      buttonBorderRadius: sizing.scale400,
      inputBorderRadius: sizing.scale400,
      popoverBorderRadius: sizing.scale400,
      surfaceBorderRadius: sizing.scale400,
    },
    colors: {
      buttonPrimaryFill: colors.green400,
      buttonPrimaryText: colors.white,
      buttonPrimaryHover: colors.green600,
      buttonPrimaryActive: colors.green600,
      buttonPrimarySelectedFill: colors.green600,
      buttonPrimarySelectedText: colors.white,
      buttonPrimarySpinnerForeground: colors.green50,
      buttonPrimarySpinnerBackground: colors.green500,
      buttonTertiaryFill: colors.green400,
      buttonTertiaryText: colors.white,
      buttonTertiaryHover: colors.green600,
      buttonTertiaryActive: colors.green600,
      buttonTertiarySelectedFill: colors.green600,
      buttonTertiarySelectedText: colors.white,
      buttonTertiarySpinnerForeground: colors.green50,
      buttonTertiarySpinnerBackground: colors.green500,
      notificationPrimaryBackground: colors.yellow50,
      notificationPrimaryText: colors.yellow500,
      notificationInfoBackground: colors.yellow50,
      notificationInfoText: colors.yellow500,
      toastPrimaryBackground: colors.yellow500,
      toastInfoBackground: colors.yellow500,
      spinnerTrackFill: colors.yellow700,
      progressbarTrackFill: colors.yellow700,
      tooltipBackground: colors.yellow700,
      tooltipText: colors.yellow50,
    },
  },
)
